import { useFrame } from '@react-three/fiber';
import { useEffect, useMemo, useRef } from 'react';
import { TextureLoader, DoubleSide } from 'three';

const Card3DAnimated = ({
	texturePath,
	position_x,
	position_z,
	position_y_start,
	position_y_final,
	onClick,
}: any) => {
	//logg("CARD", texturePath, " position ", position, " position_y_final: ", position_y_final);

	const meshRef = useRef<any>(null);

	const texture = useMemo(
		() => new TextureLoader().load(texturePath),
		[texturePath]
	);

	// 🔥 THIS is the ONLY animated value
	const y = useRef(position_y_start);
	const velocity = useRef(0);
	const started = useRef(false);
	const speed = 4.2 * 0.25;

	// INIT ONLY ON FIRST MOUNT
	useEffect(() => {
		if (!meshRef.current) return;

		meshRef.current.rotation.set(0, Math.PI * 0.5, 0);
		meshRef.current.position.set(position_x, position_y_start, position_z);
		y.current = position_y_start;

		if (!started.current) {
			started.current = true;
		}
	}, []);

	useFrame((_, delta) => {
		if (!meshRef.current) return;

		// simple gravity
		if (y.current > position_y_final) {
			velocity.current -= speed * delta;
			y.current += velocity.current;

			if (y.current <= position_y_final) {
				y.current = position_y_final;
				velocity.current = 0;
			}
		} else {
			y.current = position_y_final;
		}

		meshRef.current.position.set(position_x, y.current, position_z);
	});

	return (
		<mesh
			ref={meshRef}
			onClick={(e) => {
				e.stopPropagation();
				onClick?.();
			}}
		>
			<boxGeometry args={[2.5, 0.1, 3.5]} />
			<meshBasicMaterial map={texture} side={DoubleSide} />
		</mesh>
	);
};

export default Card3DAnimated;
